import './App.css';
import Home from './components/home/home';
import Navbar from './components/navbar'

function App() {
  
  return(
    <div className="App">
    <Navbar></Navbar>
    <Home></Home>
  </div>
  );
}

export default App;
